import { call, put, takeEvery, select, takeLatest } from 'redux-saga/effects';
import { ASYNC_READ, GET_READ_DATA, ASYNC_SAVE_MERCHANT, initialState, SAVE_MERCHANT_SUCCESS,
   ASYNC_READ_MERCHANT, READ_MERCHANT_SUCCESS, ASYNC_EDIT_MERCHANT, EDIT_MERCHANT_SUCCESS } from '../redux/ducks/merchant';


import { CreateMerchant, EditMerchant, parseStdResponseError, ReadMerchant } from '../server/WebServiceUrl';
import Axios from 'axios';
import sha256 from 'crypto-js/sha256';

async function axiosCreateMerchant(licenseData){
  let result = {
    data:{}
  };
  try{
    result = await Axios.put(CreateMerchant,licenseData);     
  }catch(e){
    if(e.response){
      result.data = e.response.data;
    }
  }
  return result.data;
}

async function axiosEditMerchant(data){
  let result = {
    data:{}
  };
  try{
    result = await Axios.post(EditMerchant, data);     
  }catch(e){
    if(e.response){
      result.data = e.response.data;
    }
  }
  return result.data;
}

async function axiosReadMerchant(code){
  let result = {};
  try{
    result = await Axios.get(ReadMerchant,{params:{code:code}});     
  }catch(e){

  }
  return result;
}

function * asyncReadMerchant(arg){
  const callback = arg.payload.callback || (() => ({}));
  const code = arg.payload.code ;  
  let res = {};

  res = yield call( axiosReadMerchant , code)

  let licensePayload = initialState;  
  if(res && res.status && res.data && res.data.pass){         
    licensePayload = {
        ...initialState,
        ...res.data.merchant
    }

    if(res.data.merchant.createDate){
      licensePayload.createDate = new Date(res.data.merchant.createDate);
    }

   }else{
        res = {
            pass: false
        }         
    }

   

  if(callback){
      callback(res)
  } 

  yield put({ type: READ_MERCHANT_SUCCESS, payload: licensePayload  });
}

function* asyncPostMerchant(arg) {     
  const callback = arg.payload.callback || (()=>({}));
  let merchant = yield select( state => state.merchant);
  //console.log(merchant);
  merchant.password = sha256(merchant.password).toString();
  let res = {};
  if(merchant.irev <= 0){
    res = yield call(
        axiosCreateMerchant,merchant
    );
   }else{
    res = yield call(
        axiosEditMerchant,merchant
    ); 
   }

   parseStdResponseError(res);

   let callbackPayload = initialState;
   
   if(res && res.pass && res.info){         
    callbackPayload = {
        ...initialState,
        ...res.info
    }
   }else{
        res = {
            pass: false
        } 
        callbackPayload.irev = 0;
    }   
   if(callback){
        callback(res)
    }

  yield put({ type: SAVE_MERCHANT_SUCCESS, payload: callbackPayload  });
}

function* asyncEditMerchant(arg) {     
  const callback = arg.payload.callback || (()=>({}));
  let res = yield call(
    axiosEditMerchant, arg.payload.data
  ); 

  parseStdResponseError(res);

   let callbackPayload = initialState;

   if(res && res.pass && res.info){         
    callbackPayload = {
        ...initialState,
        ...res.info
    }
    yield put({ type: EDIT_MERCHANT_SUCCESS, payload: callbackPayload  });
   }else{
        res = {
            pass: false
        } 
        callbackPayload.irev = 0;
    }   
   if(callback){
        callback(res)
    }

  
}


function* mySaga() {
  yield takeLatest(ASYNC_SAVE_MERCHANT, asyncPostMerchant);
  yield takeLatest(ASYNC_EDIT_MERCHANT, asyncEditMerchant);
  yield takeEvery(ASYNC_READ_MERCHANT, asyncReadMerchant);  
}

export default mySaga;
